if (!customElements.get('wavy-consultation')) {
  customElements.define(
    'wavy-consultation',
    class WavyConsultation extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.productInfo?.classList.add('product-info--wavy-consultation', 'product-info--inquiry');
        this.updateContactState();
      }

      disconnectedCallback() {
        const productInfo = this.productInfo;

        queueMicrotask(() => {
          if (productInfo && !productInfo.querySelector('wavy-consultation')) {
            productInfo.classList.remove('product-info--wavy-consultation', 'product-info--inquiry');
          }
        });
      }

      getBratislavaTimeParts() {
        const formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.dataset.timeZone || 'Europe/Bratislava',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        });
        const parts = Object.fromEntries(formatter.formatToParts(new Date()).map(({ type, value }) => [type, value]));

        return {
          weekday: parts.weekday,
          hour: Number(parts.hour),
          minute: Number(parts.minute),
        };
      }

      isBusinessOpen({ weekday, hour, minute }) {
        const weekdayIsOpen = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(weekday);
        const minutesSinceMidnight = hour * 60 + minute;

        return weekdayIsOpen && minutesSinceMidnight >= 9 * 60 && minutesSinceMidnight < 15 * 60;
      }

      updateContactState(timeParts = this.getBratislavaTimeParts()) {
        const isOpen = this.isBusinessOpen(timeParts);
        const primary = this.querySelector('[data-consultation-primary]');
        const primaryLabel = this.querySelector('[data-consultation-primary-label]');
        const status = this.querySelector('[data-consultation-status]');
        const alternative = this.querySelector('[data-consultation-alternative]');

        if (!primary || !primaryLabel || !status || !alternative) return;

        this.dataset.contactState = isOpen ? 'open' : 'closed';
        primary.href = isOpen ? this.dataset.phoneHref : this.dataset.emailHref;
        primaryLabel.textContent = isOpen
          ? this.dataset.openLabel || 'Zavolať a konzultovať vlnité vlasy'
          : this.dataset.closedLabel || 'Napísať ohľadom vlnitých vlasov';
        status.textContent = isOpen ? 'Teraz sme dostupní · do 15:00' : 'Telefonicky Po–Pi, 9:00–15:00';
        alternative.href = isOpen ? this.dataset.emailHref : this.dataset.phoneHref;
        alternative.textContent = isOpen ? 'Radšej e-mail' : 'Telefón: +421 944 229 296';
      }
    }
  );
}
